(function () {
  'use strict';
  document.querySelectorAll('[data-delivery-estimate-style]').forEach(link => { link.media = 'all'; });
  document.querySelectorAll('[data-delivery-estimate]').forEach(details => {
    if (details.dataset.initialized) return;
    details.dataset.initialized = 'true';
    const region = details.querySelector('[data-estimate-region]');
    const purchase = details.querySelector('[data-estimate-purchase]');
    const result = details.querySelector('[data-estimate-result]');
    const messages = JSON.parse(details.querySelector('[data-estimate-messages]').textContent);
    const format = (date, config) => window.ChaponDelivery.formatDate(date, config.locale || document.documentElement.lang || 'ja');
    const update = () => {
      try {
        const config = JSON.parse(details.querySelector('[data-estimate-config]').textContent);
        const estimate = window.ChaponDelivery.estimateArrival(Date.now(), Number(region.selectedOptions[0].dataset.transitDays), config);
        purchase.textContent = format(estimate.purchaseDate, config);
        result.textContent = messages.result.replace('__SHIP__', format(estimate.shipDate, config)).replace('__ARRIVE__', format(estimate.arrivalDate, config));
      } catch (error) {
        purchase.textContent = '';
        result.textContent = messages.error;
        console.error('Delivery estimate unavailable', error);
      }
    };
    region.addEventListener('change', update);
    details.addEventListener('toggle', () => { if (details.open) update(); });
    update();
    details.hidden = false;
  });
})();
